/**
 * `?fps` / `?fps=1` — show the stats.js framerate overlay.
 * Disabled when the param is absent or set to `0` / `false`.
 */
export type FpsQuery = {
    isEnabled: boolean
}

const DISABLED: FpsQuery = { isEnabled: false }

function isTruthyParam(value: string | null): boolean {
    if (value === null || value === '') {
        return true
    }
    const normalized = value.trim().toLowerCase()
    return normalized !== '0' && normalized !== 'false' && normalized !== 'off'
}

export function parseFpsQuery(search: string): FpsQuery {
    const params = new URLSearchParams(
        search.startsWith('?') ? search.slice(1) : search,
    )
    if (!params.has('fps')) {
        return DISABLED
    }
    return { isEnabled: isTruthyParam(params.get('fps')) }
}
